import { Injectable, inject } from '@angular/core';
// import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes,
	CustomerDoLogin,
	CustomerDoLoginError,
	CustomerDoLoginSuccess,
	CustomerDoRegister,
	CustomerDoRegisterError,
	CustomerDoRegisterSuccess,
	ForgotPassword,
	ForgotPasswordError,
	ForgotPasswordSuccess,
	ResetPassword,
	ResetPasswordError,
	ResetPasswordSuccess,
	SetRequestProcessing,
	UpdateProfile,
	UpdateProfileError,
	UpdateProfileSuccess,
	DeleteAcount,
	DeleteAcountSuccess,
	DeleteAcountError,
	WishlistItems,
	WishlistItemsError,
	WishlistItemsReset,
	WishlistItemsSuccess,
	GetShippingAddress,
	GetShippingAddressSuccess,
	GetShippingAddressError,
	CreateVisitor,
	CreateVisitorSuccess,
	CreateVisitorError,
	AddItemToWishlist,
	AddItemToWishlistSuccess,
	AddItemToWishlistError,
	DeleteItemToWishlist,
	DeleteItemToWishlistSuccess,
	DeleteItemToWishlistError,
	CUSTOMER_DO_LOGOUT,
	CUSTOMER_DO_LOGOUT_SUCCESS,
	CUSTOMER_DO_LOGOUT_ERROR,
	ResendOtp,
	ResendOtpSuccess,
	ResendOtpError,
	GetCityAndStateFromZipcode,
	GetCityAndStateFromZipcodeSuccess,
	GetCityAndStateFromZipcodeError
} from "./auth.actions";
import { Router } from "@angular/router";
import { ROLES } from "../../shared/interfaces";
import { AuthService } from "../../shared/services/auth.service";
import { AlertPopupService } from 'src/app/shared/services/alert-popup.service';
import { SessionService } from "../../shared/services/session.service";
import { Helper } from "../../shared/services/Helper.service";

@Injectable()
export class AuthEffects {

	// @Effect({ dispatch: false })
	// SetRequestProcessing$ = this.actions$.pipe(
	SetRequestProcessing$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.SetRequestProcessing),
			map((action: SetRequestProcessing) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// doLogin$ = this.actions$.pipe(
	doLogin$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTMER_DO_LOGIN),
			map((action: CustomerDoLogin) => action.payload),
			mergeMap((payload) => {
				return this.authService.login(payload).pipe(
					map((response: any) => {
						if (response.profile.role === ROLES[0]) {
							return new CustomerDoLoginSuccess(response);
						} else {
							return new CustomerDoLoginError({
								status: 400,
								error: {
									error: {
										message: 'Invalid Credentials',
									}
								}
							});
						}
					}),
					catchError((error) => of(new CustomerDoLoginError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// doLoginSuccess$ = this.actions$.pipe(
	doLoginSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_LOGIN_SUCCESS),
			map((action: CustomerDoLoginSuccess) => action.payload),
			mergeMap((payload) => {
				this.sessionService.setState({
					token: payload.token,
					profile: payload.profile,
					brandIds: payload.premiumCustomerOfBrands
				});
				this.router.navigate(['']);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// doLoginError$ = this.actions$.pipe(
	doLoginError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_LOGIN_ERROR),
			map((action: CustomerDoLoginError) => action.payload),
			mergeMap((payload) => {
				console.error(payload);
				this.alertService.showErrorAlert(payload.error.error.message);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CustomerDoRegister$ = this.actions$.pipe(
	CustomerDoRegister$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_REGISTER),
			map((action: CustomerDoRegister) => action.payload),
			mergeMap((payload) => {
				return this.authService.doRegister(payload).pipe(
					map((response: any) => {
						return new CustomerDoRegisterSuccess({
							regPayload: payload,
							regResponse: response
						})
					}),
					catchError((error) => of(new CustomerDoRegisterError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CustomerDoRegisterSuccess$ = this.actions$.pipe(
	CustomerDoRegisterSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_REGISTER_SUCCESS),
			map((action: CustomerDoRegisterSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert(payload.regResponse.message);
				// const queryParams = (payload.regPayload?.emailId) ? { emailId: payload.regPayload.emailId } : { mobile: payload.regPayload.mobile };
				const queryParams = { mobile: payload.regPayload.mobile };
				this.router.navigate(['verify'], { queryParams: queryParams });
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CustomerDoRegisterError$ = this.actions$.pipe(
	CustomerDoRegisterError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_REGISTER_ERROR),
			map((action: CustomerDoRegisterError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// ForgotPassword$ = this.actions$.pipe(
	ForgotPassword$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ForgotPassword),
			map((action: ForgotPassword) => action.payload),
			mergeMap((payload) => {
				return this.authService.forgotPassword(payload).pipe(
					map((response: any) => {
						return new ForgotPasswordSuccess({ response: response, emailId: payload.emailId });
					}),
					catchError((error) => of(new ForgotPasswordError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// ForgotPasswordSuccess$ = this.actions$.pipe(
	ForgotPasswordSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ForgotPasswordSuccess),
			map((action: ForgotPasswordSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert(payload.response.message);
				this.router.navigate([`/reset-password/${payload.emailId}`]);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// ForgotPasswordError$ = this.actions$.pipe(
	ForgotPasswordError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ForgotPasswordError),
			map((action: ForgotPasswordError) => action.payload),
			mergeMap((payload) => {
				console.error(payload);
				this.alertService.showErrorAlert(payload.error.error.message);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// ResetPassword$ = this.actions$.pipe(
	ResetPassword$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResetPassword),
			map((action: ResetPassword) => action.payload),
			mergeMap((payload) => {
				return this.authService.resetPassword(payload).pipe(
					map((response) => {
						return new ResetPasswordSuccess(response);
					}),
					catchError((error) => of(new ResetPasswordError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// ResetPasswordSuccess$ = this.actions$.pipe(
	ResetPasswordSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResetPasswordSuccess),
			map((action: ResetPasswordSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert('Password updated successfully. Please login with updated password.');
				this.router.navigate(['/login']);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// ResetPasswordError$ = this.actions$.pipe(
	ResetPasswordError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResetPasswordError),
			map((action: ResetPasswordError) => action.payload),
			mergeMap((payload) => {
				console.error(payload);
				this.alertService.showErrorAlert(payload.error.error.message);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// UpdateProfile$ = this.actions$.pipe(
	UpdateProfile$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.UpdateProfile),
			map((action: UpdateProfile) => action.payload),
			mergeMap((payload) => {
				return this.authService.UpdateProfile(payload).pipe(
					map((response) => {
						return new UpdateProfileSuccess(response);
					}),
					catchError((error) => of(new UpdateProfileError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// UpdateProfileSuccess$ = this.actions$.pipe(
	UpdateProfileSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.UpdateProfileSuccess),
			map((action: UpdateProfileSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert('Profile saved successfully');

				/*
				* updating data in local storage
				* */
				let state = this.sessionService.state;
				if (state) {
					this.sessionService.setState({ token: state.token, profile: payload, brandIds: state.brandIds });
				}

				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// UpdateProfileError$ = this.actions$.pipe(
	UpdateProfileError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.UpdateProfileError),
			map((action: UpdateProfileError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// DeleteAcount$ = this.actions$.pipe(
	DeleteAcount$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteAcount),
			map((action: DeleteAcount) => action.payload),
			mergeMap((payload) => {
				return this.authService.DeleteAcount(payload).pipe(
					map((response) => {
						return new DeleteAcountSuccess(response);
					}),
					catchError((error) => of(new DeleteAcountError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// DeleteAcountSuccess$ = this.actions$.pipe(
	DeleteAcountSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteAcountSuccess),
			map((action: DeleteAcountSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert('Profile Deleted Successfully');

				/*
				* updating data in local storage
				* */
				let state = this.sessionService.state;
				if (state) {
					this.sessionService.unsetState();
				}
				this.router.navigate(['/login']);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// DeleteAcountError$ = this.actions$.pipe(
	DeleteAcountError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteAcountError),
			map((action: DeleteAcountError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	WishlistItems$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.WishlistItems),
			map((action: WishlistItems) => action.payload),
			mergeMap((payload) => {
				return this.authService.WishlistItems(payload).pipe(
					map((response) => {
						return new WishlistItemsSuccess(response);
					}),
					catchError((error) => of(new WishlistItemsError(error)))
				)
			})
		);
	});

	WishlistItemsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.WishlistItemsSuccess),
			map((action: WishlistItemsSuccess) => action.payload),
			mergeMap((payload) => {
				return of(new WishlistItemsReset());
			})
		);
	});

	WishlistItemsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.WishlistItemsError),
			map((action: WishlistItemsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });

	// @Effect()
	// GetShippingAddress$ = this.actions$.pipe(
	GetShippingAddress$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShippingAddress),
			map((action: GetShippingAddress) => action.payload),
			mergeMap((payload) => {
				return this.authService.GetShippingAddress().pipe(
					map((response) => {
						return new GetShippingAddressSuccess(response);
					}),
					catchError((error) => of(new GetShippingAddressError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetShippingAddressSuccess$ = this.actions$.pipe(
	GetShippingAddressSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShippingAddressSuccess),
			map((action: GetShippingAddressSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetShippingAddressError$ = this.actions$.pipe(
	GetShippingAddressError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetShippingAddressError),
			map((action: GetShippingAddressError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CreateVisitor$ = this.actions$.pipe(
	CreateVisitor$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateVisitor),
			map((action: CreateVisitor) => action.payload),
			mergeMap((payload) => {
				return this.authService.CreateVisitor({}).pipe(
					map((response) => {
						return new CreateVisitorSuccess(response);
					}),
					catchError((error) => of(new CreateVisitorError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CreateVisitorSuccess$ = this.actions$.pipe(
	CreateVisitorSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateVisitorSuccess),
			map((action: CreateVisitorSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CreateVisitorError$ = this.actions$.pipe(
	CreateVisitorError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateVisitorError),
			map((action: CreateVisitorError) => action.payload),
			mergeMap((payload) => {
				// this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// AddItemToWishlist$ = this.actions$.pipe(
	AddItemToWishlist$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddItemToWishlist),
			map((action: AddItemToWishlist) => action.payload),
			mergeMap((payload) => {
				return this.authService.AddItemToWishlist(payload.itemId).pipe(
					map((response) => {
						return new AddItemToWishlistSuccess(response);
					}),
					catchError((error) => of(new AddItemToWishlistError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// AddItemToWishlistSuccess$ = this.actions$.pipe(
	AddItemToWishlistSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddItemToWishlistSuccess),
			map((action: AddItemToWishlistSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert('Item Add To Wishlist successfully');
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// AddItemToWishlistError$ = this.actions$.pipe(
	AddItemToWishlistError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.AddItemToWishlistError),
			map((action: AddItemToWishlistError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// DeleteItemToWishlist$ = this.actions$.pipe(
	DeleteItemToWishlist$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemToWishlist),
			map((action: DeleteItemToWishlist) => action.payload),
			mergeMap((payload) => {
				return this.authService.DeleteItemToWishlist(payload.itemId).pipe(
					map((response) => {
						return new DeleteItemToWishlistSuccess(response);
					}),
					catchError((error) => of(new DeleteItemToWishlistError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// DeleteItemToWishlistSuccess$ = this.actions$.pipe(
	DeleteItemToWishlistSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemToWishlistSuccess),
			map((action: DeleteItemToWishlistSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertService.showInfoAlert('Item Remove From Wishlist successfully');
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// DeleteItemToWishlistError$ = this.actions$.pipe(
	DeleteItemToWishlistError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.DeleteItemToWishlistError),
			map((action: DeleteItemToWishlistError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false })
	// );

	// @Effect()
	// CUSTOMER_DO_LOGOUT$ = this.actions$.pipe(
	CUSTOMER_DO_LOGOUT$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_LOGOUT),
			map((action: CUSTOMER_DO_LOGOUT) => action.payload),
			mergeMap((payload) => {
				return this.authService.CUSTOMER_DO_LOGOUT().pipe(
					map((response) => {
						return new CUSTOMER_DO_LOGOUT_SUCCESS(response);
					}),
					catchError((error) => of(new CUSTOMER_DO_LOGOUT_ERROR(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CUSTOMER_DO_LOGOUT_SUCCESS$ = this.actions$.pipe(
	CUSTOMER_DO_LOGOUT_SUCCESS$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_LOGOUT_SUCCESS),
			map((action: CUSTOMER_DO_LOGOUT_SUCCESS) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CUSTOMER_DO_LOGOUT_ERROR$ = this.actions$.pipe(
	CUSTOMER_DO_LOGOUT_ERROR$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CUSTOMER_DO_LOGOUT_ERROR),
			map((action: CUSTOMER_DO_LOGOUT_ERROR) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// ResendOtp$ = this.actions$.pipe(
	ResendOtp$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResendOtp),
			map((action: ResendOtp) => action.payload),
			mergeMap((payload) => {
				return this.authService.ResendOtp(payload).pipe(
					map((response) => {
						return new ResendOtpSuccess(response);
					}),
					catchError((error) => of(new ResendOtpError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// ResendOtpSuccess$ = this.actions$.pipe(
	ResendOtpSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResendOtpSuccess),
			map((action: ResendOtpSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// ResendOtpError$ = this.actions$.pipe(
	ResendOtpError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.ResendOtpError),
			map((action: ResendOtpError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetCityAndStateFromZipcode$ = this.actions$.pipe(
	GetCityAndStateFromZipcode$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCityAndStateFromZipcode),
			map((action: GetCityAndStateFromZipcode) => action.payload),
			mergeMap((payload) => {
				return this.authService.GetCityAndStateFromZipcode(payload).pipe(
					map((response) => {
						return new GetCityAndStateFromZipcodeSuccess(response);
					}),
					catchError((error) => of(new GetCityAndStateFromZipcodeError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetCityAndStateFromZipcodeSuccess$ = this.actions$.pipe(
	GetCityAndStateFromZipcodeSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCityAndStateFromZipcodeSuccess),
			map((action: GetCityAndStateFromZipcodeSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetCityAndStateFromZipcodeError$ = this.actions$.pipe(
	GetCityAndStateFromZipcodeError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCityAndStateFromZipcodeError),
			map((action: GetCityAndStateFromZipcodeError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private authService: AuthService,
		private alertService: AlertPopupService,
		private sessionService: SessionService,
		private router: Router,
		private helper: Helper,
	) { }

}
